export default "__VITE_ASSET__BE9TaLHt__"